<template>
  <div>

    <Head title="Ruta | Empleados" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-sky-400 hover:text-sky-600" href="/routes">Rutas</Link>
      <span class="text-sky-400 font-medium">/</span> Encargado(s)
    </h1>

  </div>
  <div class="flex items-left justify-end mb-6 mx-1">
    <button class="btn-sky" @click="showDialog">Agregar Encargado</button>
  </div>
  <div class="bg-white rounded-md shadow overflow-x-auto">
    <table class="w-full whitespace-nowrap">
      <tr class="text-left font-bold">
        <th class="pb-4 pt-6 px-2">Nombre</th>
        <th class="pb-4 pt-6 px-2">Apellido</th>
        <th class="pb-4 pt-6 px-2">Email</th>
        <th class="pb-4 pt-6 px-2">Acción</th>
        <th class="pb-4 pt-6 px-2">Visitas</th>
      </tr>

      <tr v-for="client in employee" :key="client.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
        <td class="border-t">
          <Link class="flex items-center px-6 py-4">
          {{ client.first_name }}
          </Link>
        </td>
        <td class="border-t">
          <Link class="flex items-center px-6 py-4">
          {{ client.last_name }}
          </Link>
        </td>
        <td class="border-t">
          <Link class="flex items-center px-6 py-4">
          {{ client.email }}
          </Link>
        </td>
        <td class="border-t">
          <Link class="flex items-center px-6 py-4">
          <button class="btn-delete" @click="removeEmployee(client.id)">Remover</button>
          </Link>
        </td>
        <td class="border-t">
          <button class="btn-orange" @click="showDialogVisit(client.id_user)">
            <icon name="map-pin" /> <!-- Clase de icono de Font Awesome -->
          </button>
        </td>

      </tr>
      <tr v-if="employee.length === 0">
        <td class="px-6 py-4 border-t" colspan="14">La ruta no cuenta con empleados asignados.</td>
      </tr>
    </table>
  </div>
  <div>
    <DialogInput v-if="showDialogInput" v-model="dialogValue" label="Nombre" :title="'Agregar encargado a la ruta'"
      @close="closeDialog">
      <form class="w-full max-w-sm py-2" @submit.prevent="storeClients">
        <div v-if="availableEmployees.length != 0">
          <div>
            <select-input v-model="form.id_user" class="py-2 w-full" label="Empleado">
              <option v-for="clie in availableEmployees" :key="clie.id" :value="clie.id">{{ clie.first_name }}</option>
            </select-input>
          </div>
          <div class="flex items-center justify-center px-8 py-4">
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Agregar</loading-button>
          </div>
        </div>
        <div v-else>
          <p style="display: flex; text-align: center; justify-content: center;">No hay empleados disponibles</p>
        </div>
      </form>
    </DialogInput>
  </div>
  <div>
    <DialogInput v-if="dialogVisit" label="Nombre" :title="'Visitas realizadas'" @close="closeDialogVisit">
    <div class="dialog-search">
      <text-input
        v-model="date_visit_route"
        type="date"
        id="date_start"
        class="mt-1 block w-full"          
      />
      <loading-button class="btn-sky" type="button" @click="showListJourneyVisit">
        Buscar
      </loading-button>
    </div>
    
    <div v-if="show_response_journey" class="dialog-table-container">
      <div v-if="journey_visit.length != 0" class="bg-white rounded-md shadow">
        <table class="w-full whitespace-nowrap">
          <thead>
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-2">Fecha de Inicio</th>
              <th class="pb-4 pt-6 px-2">Status</th>
              <th class="pb-4 pt-6 px-2">Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="journey in journey_visit" :key="journey.id">
              <td class="border-t px-2 py-2">{{ journey.start_date }}</td>
              <td class="border-t px-2 py-2">
                <div :class="['status-badge', journey.status === 0 ? 'status-finished' : 'status-active']">
                  {{ journey.status === 0 ? 'Terminada' : 'Activa' }}
                </div>
              </td>
              <td class="border-t px-2 py-2">
                <button class="btn-orange" @click="goToRouteJourney(journey.id)">
                  Ver
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <p>No hay rutas iniciadas asociadas a la fecha indicada</p>
      </div>
    </div>
  </DialogInput>
  </div>

</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import Icon from '@/Shared/Icon'
import mapValues from 'lodash/mapValues'
import DialogInput from '@/Shared/Dialog'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Search from '@/Shared/Search'
import Pagination from '@/Shared/Pagination'
import Swal from 'sweetalert2'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    Head,
    Link,
    DialogInput,
    LoadingButton,
    SelectInput,
    Search,
    Icon,
    Pagination,
    VueDatePicker,
    TextInput
  },
  layout: Layout,
  props: {
    employee: Array,
    availableEmployees: Array,
    clie: Array,
    routeId: String,
    user_route_journey: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        id_user: '',
        id_route: this.routeId,
        //search: this.filters.search,
        // code: this.filters.code,
      }),
      dialogValue: '',
      showDialogInput: false, // Nuevo dato para controlar la visibilidad del diálogo        
      dialogVisit: false,
      date_visit_route: null,
      journey_visit: [],
      id_user_journey_visit: null,
      show_response_journey: false

    }
  },
  watch: {

  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    showDialog() {
      this.showDialogInput = true // Mostrar el diálogo al hacer clic en el botón
    },
    closeDialog() {
      this.showDialogInput = false // Cerrar el diálogo cuando se emite el evento 'close'
    },
    showDialogVisit(id_user) {
      this.dialogVisit = true
      this.id_user_journey_visit = id_user
      //console.log("El user es: "+ id_user )
    },
    closeDialogVisit() {
      this.dialogVisit = false;
      // Limpiar los datos de la búsqueda anterior
      this.journey_visit = []; // Vaciar los registros de visitas
      this.show_response_journey = false; // Ocultar los resultados anteriores
      this.date_visit_route = null; // Resetear la fecha si es necesario
    },
    searchRoutes() {
      console.log("La fecha es:  " + this.date_visit_route)
    },
    show_message() {
      console.log("Se imprime perro")
    },
    showListJourneyVisit() {
      console.log("La fecha es:  " + this.date_visit_route)
      this.show_response_journey = true
      if (this.date_visit_route != null) {
        // Obtener la fecha en formato YYYY-MM-DD
        const fechaVisitRoute = this.date_visit_route;
        // Filtrar el array original
        let id_user_journey_visit = this.id_user_journey_visit
        this.journey_visit = this.user_route_journey.filter(function (item) {
          // Convertir la fecha de inicio a un objeto Date
          const fechaInicio = item.start_date.slice(0, 10); // Obtiene 'YYYY-MM-DD'          
          // Comparar el id_user y la fecha (sin considerar horas, minutos y segundos)          
          return item.id_user === id_user_journey_visit && fechaInicio == fechaVisitRoute;
        });
      } else {
        alert("Elige una fecha");
      }
    },
    goToRouteJourney(id_journey) {
      window.location.href = `/routes/journey/${id_journey}`
      console.log("El id_journey es: " + id_journey)
    },
    storeClients() {
      // Utilizando async/await para esperar la respuesta del envío de datos
      (async () => {
        try {
          await this.$inertia.post('/route_employee', this.form)
          // Si la respuesta es exitosa, cierra el diálogo
          this.closeDialog()
          // Puedes agregar aquí cualquier lógica adicional después de enviar los datos
        } catch (error) {
          console.error('Error al enviar datos:', error)
          // Puedes manejar el error aquí si es necesario
        }
      })()
    },
    getRouteDescription(number) {
      const route = this.allRoute.find(cat => cat.id === number)
      return route ? route.descripcion : 'Ruta no disponible'
    },
    getClientDescription(number) {
      const client = this.allClients.find(cat => cat.id === number)
      return client ? client.cliente : 'Cliente no disponible'
    },
    removeEmployee(number) {
      //let id_route_client =this.routeClients.find(cat => cat.id_client_route == number)
      Swal.fire({
        title: 'Remover empleado',
        text: '¿Deseas quitar al empleado de la ruta?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Remover!',
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Removido!',
            text: 'El empleado ha sido removido.',
            icon: 'success',
          })
          this.$inertia.delete(`/route_user/${number}`)
        }
      })
    },
  },
}
</script>

<style scoped>
.dialog-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.dialog-search .btn-sky {
  margin-left: 10px;
}

.dialog-table-container {
  /* max-height: 400px; */
  overflow-y: auto;
}

.status-badge {
  padding: 5px 10px;
  border-radius: 5px;
  color: white;
  text-align: center;
}

.status-finished {
  background-color: grey;
}

.status-active {
  background-color: green;
}
</style>